export const fonts = {
  families: {
    primary: "'Bungee', Arial, sans-serif",
    secondary: "'SyneMono', Arial, sans-serif",
    fallback: 'Arial, sans-serif',
  },
  
  sizes: {
    xs: '0.9rem',
    sm: '1rem',
    md: '1.1rem',
    lg: '1.2rem',
    xl: '1.5rem',
    xxl: '16px',
    responsive: 'clamp(14px, 1.2vw, 18px)',
    desktopMd: '1.25rem',
    desktopLg: '1.3rem',
    desktopXl: '1.8rem',
    desktopXxl: '2.5rem',
  },
  
  weights: {
    normal: 'normal',
    bold: 'bold',
  },
  
  textTransform: {
    uppercase: 'uppercase',
    none: 'none',
  },
  
  letterSpacing: {
    normal: 'normal',
    wide: '1px',
  },
  
  lineHeight: {
    normal: 'normal',
    relaxed: '1.4',
  },
} as const;

export type Fonts = typeof fonts;